// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3MhI9","input":"styles_input__2BUGD"};